export const PASSPORT_DOWNLOAD = {
  action: 'passport-download',
  tooltip: 'Скачать данные',
  icon: 'mdi-file-download-outline',
}

export const PASSPORT_ACTIVE = {
  action: 'passport-active',
  tooltip: 'Активация\\деактивация Паспорта',
  icon: 'mdi-file-download-outline',
}
